import { render, staticRenderFns } from "./GenericAttributeInput.vue?vue&type=template&id=202d9632&scoped=true&"
import script from "./GenericAttributeInput.vue?vue&type=script&lang=js&"
export * from "./GenericAttributeInput.vue?vue&type=script&lang=js&"
import style0 from "./GenericAttributeInput.vue?vue&type=style&index=0&id=202d9632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d9632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
